import { render, staticRenderFns } from "./DiceTray.vue?vue&type=template&id=0af3e82c"
import script from "./DiceTray.vue?vue&type=script&lang=js"
export * from "./DiceTray.vue?vue&type=script&lang=js"
import style0 from "./DiceTray.vue?vue&type=style&index=0&id=0af3e82c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports